import { cn, PageLoader } from '@prenuvo/halo-foundation';

import { PageLoaderGif } from '@/assets/icons';

interface LoadingProps {
  className?: string;
}

export function Loading({ className }: LoadingProps) {
  return (
    <div className={cn('flex h-screen items-center justify-center', className)}>
      <PageLoader src={PageLoaderGif} variant="dark" />
    </div>
  );
}
